// WARNING: Automatically generated code. Any changes to this file will be overwritten.
import { arrayToPickyDict, Dict } from '@nk/utils-lib';
import { DimContainer, DimFlagContainer } from '../types/app-dim-types';
import { PartnerReportTypeEntity } from './app-base-report';


// report.partner_report_type.partner_report_type_key
export enum PartnerReportTypeKey {
  brreg_company_bankruptcy_report = 'brreg_company_bankruptcy_report',
  brreg_company_certificate = 'brreg_company_certificate',
  brreg_company_collateral_report = 'brreg_company_collateral_report',
  brreg_company_name_report = 'brreg_company_name_report',
  brreg_company_registry_report = 'brreg_company_registry_report',
  brreg_company_role_report = 'brreg_company_role_report',
  creditsafe_json_company_report = 'creditsafe_json_company_report',
  creditsafe_pdf_company_report = 'creditsafe_pdf_company_report',
  mock_report = 'mock_report',
  no_kartverket_grunnbokutskrift_report = 'no_kartverket_grunnbokutskrift_report',
}

// report.partner_report_type.partner_report_type_key
export class PartnerReportTypeDims implements DimContainer<PartnerReportTypeKey>, DimFlagContainer {
  public flags:
    | {
        brreg_company_bankruptcy_report: boolean;
        brreg_company_certificate: boolean;
        brreg_company_collateral_report: boolean;
        brreg_company_name_report: boolean;
        brreg_company_registry_report: boolean;
        brreg_company_role_report: boolean;
        creditsafe_json_company_report: boolean;
        creditsafe_pdf_company_report: boolean;
        mock_report: boolean;
        no_kartverket_grunnbokutskrift_report: boolean;
      }
    | Dict<boolean>;
  public dims: PartnerReportTypeEntity[];
  public keys: PartnerReportTypeKey[];

  constructor(dims: PartnerReportTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.partner_report_type_key,
      (d) => true
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.partner_report_type_key as PartnerReportTypeKey);
  }
}
